import styled, { css, keyframes } from "styled-components";
import { InputNumber } from 'antd';

export const ProductContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  div {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    p {
      margin-bottom: 0px;
      font-weight: 600;
      font-size: 16px;
      color: #314158;
      -webkit-line-clamp: 1;
    }
    span,
    p {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: "Inter", sans-serif;
      line-height: 125%;
      letter-spacing: 0%;
    }
    span {
      line-height: 120%;
      color: #62748e;
      -webkit-line-clamp: 1;
      ${({ descMoreLines }) =>
        descMoreLines &&
        css`
          -webkit-line-clamp: 2;
        `}
    }
  }

  ${({ checkout }) =>
    checkout &&
    css`
      animation: fadeIn 0.5s ease-in-out;
      opacity: 1;
      gap: 8px;

      p {
        font-weight: 600 !important;
        font-size: 14px !important;
      }
      span {
        font-weight: 400 !important;
        font-size: 14px !important;
      }
    `}
  .ant-select-selection-item,
  .ant-select-item-option-content {
    color: #314158 !important;
  }
  .ant-select-selection-item {
    font-family: "Inter", sans-serif !important;
    font-size: 14px !important;
    overflow: unset !important;
  }
  .ant-select-selector {
    border-radius: 8px !important;
    svg {
    }
  }

  .anticon > svg {
    transition: all 300ms ease-in-out;
    width: 10px !important;
  }

  .ant-select-open .anticon > svg {
    transform: rotateZ(180deg);
  }
`;

export const InfoValue = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  flex-direction: row !important;
`;

const skeletonLoading = keyframes`
0% {
    background-position: 100% 50%;
}

100% {
    background-position: 0 50%;
}
`;

export const SkeletonDiv = styled.div`
  --gradient-from-color: rgba(0, 0, 0, 0.06);
  --gradient-to-color: rgba(0, 0, 0, 0.15);

  width: ${({ width }) => width ?? "100%"} !important;
  border-radius: ${({ borderRadius }) => borderRadius ?? "6px"};
  height: ${({ height }) => height ?? "24px"};

  background: linear-gradient(
    90deg,
    var(--gradient-from-color) 25%,
    var(--gradient-to-color) 37%,
    var(--gradient-from-color) 63%
  );
  background-size: 400% 100%;
  animation-name: ${skeletonLoading};
  animation-duration: ${({ duration }) => duration ?? "1.5s"};
  animation-timing-function: ease;
  animation-iteration-count: infinite;
`;

export const IntegerInputNumber = styled(InputNumber)`
  border-radius: 8px !important;
  width: 150px !important;
  
  .ant-input-number {
    border-radius: 8px !important;
  }
  
  .ant-input-number-input {
    border-radius: 8px 0 0 8px !important;
  }
  
  .ant-input-number-handler-wrap {
    width: 30%;
    border-radius: 0 8px 8px 0 !important;
    border-left: 1px solid #d9d9d9;
    
    .ant-input-number-handler {
      border-radius: 0 !important;
      transition: none !important;
      position: relative !important;
      
      &:hover {
        transform: none !important;
        background-color: #f5f5f5 !important;
        position: relative !important;
      }
      
      &:active {
        transform: none !important;
        background-color: #e6f7ff !important;
        position: relative !important;
      }
    }
    
    .ant-input-number-handler-up {
      border-radius: 0 8px 0 0 !important;
      border-bottom: 1px solid #d9d9d9;
      transition: none !important;
      position: relative !important;
      
      &:hover {
        transform: none !important;
        background-color: #f5f5f5 !important;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
      }
      
      &:active {
        transform: none !important;
        background-color: #e6f7ff !important;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
      }
    }
    
    .ant-input-number-handler-down {
      border-radius: 0 0 8px 0 !important;
      transition: none !important;
      position: relative !important;
      
      &:hover {
        transform: none !important;
        background-color: #f5f5f5 !important;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
      }
      
      &:active {
        transform: none !important;
        background-color: #e6f7ff !important;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
      }
    }
  }
  
  &:hover .ant-input-number-handler-wrap {
    border-color: #40a9ff !important;
  }
  
  &:focus .ant-input-number-handler-wrap {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }
`
